import axios from "axios";
import { API_URL } from "../../const";

/*************** LENDER DETAILS ADD START *************** */
export const lenderDetailsAdd = (addData: any) => {
  const data = {
    CreateLenderToken: addData,
  };
  const url = `${API_URL}CreateLender`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** LENDER DETAILS ADD END *************** */

/*************** LENDER DETAILS UPDATE START *************** */
export const lenderDetailsUpdate = (updateData: any) => {
  const data = {
    UpdateLenderDetailsToken: updateData,
  };
  const url = `${API_URL}UpdateLender`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** LENDER DETAILS UPDATE END *************** */

/*************** LENDER DETAILS GET START *************** */
export const lenderListGet = (listData: any) => {
  const data = {
    GetAllLenderPaginationToken: listData,
  };
  const url = `${API_URL}GetAllLenderDetailsPagination`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** LENDER DETAILS GET END *************** */

/*************** LENDER DETAILS FETCH START *************** */
export const lenderDetailsFetch = (fetchData: any) => {
  const data = {
    FetchLenderDetailsToken: fetchData,
  };
  const url = `${API_URL}FetchLenderDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** LENDER DETAILS FETCH END *************** */

/*************** LENDER DETAILS DELETE START *************** */
export const lenderDetailsDelete = (deleteData: any) => {
  const data = {
    DeleteLenderToken: deleteData,
  };
  const url = `${API_URL}DeleteLender`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** LENDER DETAILS DELETE END *************** */

/** *************** START LENDER LIST FETCH DETAILS ***************** */

export const fetchListLender = (fetchData: JSON) => {
  const data = {
    AllLenderMasterToken: fetchData,
  };

  const url = `${API_URL}GetAllLenderMaster`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

/** *************** END LENDER LIST FETCH DETAILS ***************** */
